export default "__VITE_ASSET__Bbd9gCzh__"